import { OptionModel } from '@/shared/lib/types'

export const REQUISITE_OPTIONS: OptionModel[] = [
  { label: 'Реквизиты', value: 'requisites', index: 0 },
  { label: 'Фермы', value: 'farms', index: 1 },
]
